import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

export const Api = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://tumq-backend.vercel.app/',
        prepareHeaders: (headers, { pageParam }) => {
            if (pageParam) {
                headers.set('page', String(pageParam));
            }
            return headers;
        }
    }),

    endpoints: (builder) => ({
        getServersByCategory: builder.query({query: (info) => `servers/?category=${info.category}&page=${info.page}` }),
        getMyServers: builder.query({query: (info) => `my-servers/?userName=${info.username}&page=${info.pages}` }),
        getSingleServer: builder.query({query: (serverId) => `server/?serverId=${serverId}` }),

        signUp: builder.mutation({
            query: (data) => ({
                url: "auth/sign-up",
                method: "POST",
                body: data
            })
        }),
        logIn: builder.mutation({
            query: (data) => ({
                url: "auth/log-in",
                method: "POST",
                body: data
            })
        }),
        AddServer: builder.mutation({
            query: (data) => ({
                url: "servers/add-server",
                method: "POST",
                body: data
            })
        }),
        EditServer: builder.mutation({
            query: (data) => ({
                url: "servers/edit-server",
                method: "POST",
                body: data
            })
        }),
        DelServer: builder.mutation({
            query: (data) => ({
                url: "servers/delete-server",
                method: "POST",
                body: data
            })
        }),
        voteServer: builder.mutation({
            query: (data) => ({
                url: "server/vote-server",
                method: "POST",
                body: data
            })
        }),
    })
});

export const { useSignUpMutation, useLogInMutation, useGetUserDataQuery, useMakeItPremiumMutation, useDelServerMutation, useGetFeaturedServersQuery, useGetServersByCategoryQuery, useAddServerMutation, useGetSingleServerQuery, useGetMyServersQuery, useEditServerMutation, useVoteServerMutation } = Api;
